<template>
    <div id="FormDropDownList">
        <div :class="`form-drop-downList dropdown-align-${align}`">
            <label class="form-drop-down-title">
                {{ displayFieldLabel }}
            </label>
            <div>
                <select v-model="selectedOption" class="form-drop-down-select" @change="updateField" @blur="updateField">
                    <option disabled value="">{{ placeholder || "Seçiniz..." }}</option>
                    <option v-for="option in options" :key="option" :value="option">{{ option }}</option>
                </select>
                <div class="options-management">
                    <textarea v-model="newOptions" class="form-drop-down-textarea"
                              placeholder="seçenek 1&#10;seçenek 2" @blur="addOptions"></textarea>
                    <button @click="addOptions" class="form-drop-down-button">Seçenek Ekle</button>
                    <button @click="toggleOptions" class="form-drop-down-button">
                        {{ showOptions ? "Seçenekleri Gizle" : "Seçenekleri Göster" }}
                    </button>
                    <div v-if="showOptions" class="remove-options">
                        <div v-for="option in options" :key="option" class="option-item">
                            {{ option }}
                            <button @click="removeOption(option)" class="remove-button">
                                <md-icon style="color: white">delete</md-icon>
                            </button>
                        </div>
                    </div>
                </div>
                <input type="text" class="form-drop-down-sublabel" v-model="localAltLabel" @input="updateField" @blur="updateField">
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "DropDownList",
    props: {
        fieldLabel: String,
        placeholder: String,
        align: String,
        altLabel: String,
        isRequired: Boolean,
        item: Object,
    },
    data() {
        return {
            selectedOption: "",
            options: [],
            newOptions: "",
            showOptions: false,
            localFieldLabel: this.fieldLabel || "",
            localAltLabel: this.altLabel || "",
            editingFieldLabel: false,
            updateTimer: null,
        };
    },
    computed: {
        displayFieldLabel() {
            return this.localFieldLabel || "Bir soru girin";
        },
    },
    watch: {
        item: {
            handler(newItem) {
                if (newItem && newItem.dropDownList && newItem.dropDownList.items) {
                    this.options = newItem.dropDownList.items;
                }
            },
            immediate: true,
            deep: true,
        },
    },
    methods: {
        ...mapActions("forms", ["updateFormField"]),
        addOptions() {
            const newOptionsArray = this.newOptions.split("\n").map(option => option.trim()).filter(option => option);
            this.options = [...new Set([...this.options, ...newOptionsArray])];
            this.newOptions = "";
            this.updateField();
        },
        removeOption(optionToRemove) {
            this.options = this.options.filter(option => option !== optionToRemove);
            this.updateField();
        },
        updateField() {
            let self = this;
            if (this.updateTimer) {
                clearTimeout(this.updateTimer);
            }
            this.updateTimer = setTimeout(function () {
            const updateFields = {
                dropDownList: {
                        fieldLabel: self.localFieldLabel,
                        align: self.align,
                        altLabel: self.localAltLabel,
                        isRequired: self.isRequired,
                        items: self.options,
                        placeholder: self.placeholder,
                    },
                };
                self.updateFormField({
                    siteId: self.item.siteId,
                    formFieldId: self.item._id,
                updateFields: updateFields,
            });
                self.$emit("update-field", updateFields);
            }, 200);
        },
        toggleOptions() {
            this.showOptions = !this.showOptions;
        },
    },
    watch: {
        altLabel(newVal) {
            this.localAltLabel = newVal || "";
        },
    },
    created() {
        if (this.item && this.item.dropDownList && this.item.dropDownList.items) {
            this.options = this.item.dropDownList.items;
        }
    },
};
</script>

<style lang="scss" scoped>
#FormDropDownList {
    .form-drop-downList {
        margin: clamp(0.5rem, 1.5vw, 1rem) auto;
        padding: clamp(0.625rem, 1.5vw, 0.875rem);
        max-width: 700px;
        width: 100%;
        box-sizing: border-box;
        background: linear-gradient(145deg, 
            rgba(255, 255, 255, 0.02) 0%,
            rgba(255, 255, 255, 0.01) 100%);
        border-radius: 0.75rem;
        border: 1px solid rgba(255, 255, 255, 0.06);
        transition: all 0.3s ease;

        &:hover {
            background: linear-gradient(145deg, 
                rgba(255, 255, 255, 0.03) 0%,
                rgba(255, 255, 255, 0.02) 100%);
        }

        .form-drop-down-title {
            display: block;
            font-size: clamp(0.95rem, 2.2vw, 1.1rem);
            font-weight: 600;
            margin-bottom: clamp(0.5rem, 1.2vw, 0.75rem);
            color: rgba(55, 65, 81, 0.9);
            border: none;
            padding: 0;
            width: 100%;
            background: transparent;
        }

        .form-drop-down-select {
            width: 100%;
            min-width: 0;
            padding: clamp(0.6rem, 1.5vw, 0.75rem);
            border: 1px solid rgba(209, 213, 219, 0.6);
            border-radius: 0.375rem;
            font-size: clamp(0.875rem, 1.8vw, 0.9rem);
            background: rgba(255, 255, 255, 0.8);
            color: rgba(55, 65, 81, 0.9);
            margin-bottom: clamp(0.5rem, 1.2vw, 0.75rem);
            backdrop-filter: blur(10px);
            transition: all 0.3s ease;
            font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
            box-sizing: border-box;

            &:focus {
                outline: none;
                border-color: #f26a52;
                box-shadow: 0 0 0 3px rgba(242, 106, 82, 0.1);
                background: rgba(255, 255, 255, 0.95);
            }

            &:hover:not(:focus) {
                border-color: rgba(107, 114, 128, 0.4);
                background: rgba(255, 255, 255, 0.85);
            }
        }

        .options-management {
            margin-top: clamp(0.5rem, 1.2vw, 0.75rem);
            padding: clamp(0.5rem, 1.2vw, 0.75rem);
            background: rgba(248, 250, 252, 0.8);
            border-radius: 0.5rem;
            border: 1px solid rgba(226, 232, 240, 0.8);
            width: 100%;
            box-sizing: border-box;
        }

        .form-drop-down-textarea {
            width: 100%;
            min-width: 0;
            padding: clamp(0.5rem, 1.2vw, 0.75rem);
            border: 1px solid rgba(209, 213, 219, 0.6);
            border-radius: 0.375rem;
            font-size: clamp(0.875rem, 1.8vw, 0.9rem);
            min-height: 80px;
            margin-bottom: clamp(0.5rem, 1.2vw, 0.75rem);
            resize: vertical;
            font-family: inherit;
            background: rgba(255, 255, 255, 0.9);
            transition: border-color 0.2s ease;
            box-sizing: border-box;

            &:focus {
                outline: none;
                border-color: #f26a52;
                box-shadow: 0 0 0 2px rgba(242, 106, 82, 0.1);
            }

            &::placeholder {
                color: rgba(107, 114, 128, 0.6);
            }
        }

        .form-drop-down-button {
            display: inline-block;
            padding: clamp(0.5rem, 1.2vw, 0.625rem) clamp(0.75rem, 1.5vw, 1rem);
            background-color: #f26a52;
            color: white;
            border: none;
            border-radius: 0.375rem;
            font-size: clamp(0.8rem, 1.6vw, 0.875rem);
            font-weight: 500;
            cursor: pointer;
            margin-right: clamp(0.375rem, 1vw, 0.5rem);
            margin-bottom: clamp(0.375rem, 1vw, 0.5rem);
            transition: all 0.2s ease;

            &:hover {
                background-color: #e55a42;
                transform: translateY(-1px);
                box-shadow: 0 2px 8px rgba(242, 106, 82, 0.3);
            }
        }

        .form-drop-down-sublabel {
            font-size: clamp(0.75rem, 1.6vw, 0.8rem);
            color: rgba(107, 114, 128, 0.8);
            border: none;
            border-bottom: 1px solid rgba(209, 213, 219, 0.6);
            padding: clamp(0.25rem, 0.8vw, 0.375rem) 0;
            width: 100%;
            min-width: 0;
            background: transparent;
            margin-top: clamp(0.25rem, 0.8vw, 0.375rem);
            transition: border-color 0.2s ease;
            box-sizing: border-box;

            &:focus {
                outline: none;
                border-bottom-color: #f26a52;
            }
        }
    }

    .dropdown-align-left,
    .dropdown-align-right {
        display: flex;
        align-items: flex-start;
        gap: clamp(0.75rem, 2vw, 1rem);

        .form-drop-down-title {
            min-width: clamp(80px, 15vw, 120px);
            max-width: clamp(120px, 25vw, 180px);
            flex-shrink: 0;
            margin-bottom: 0;
            padding-top: clamp(0.6rem, 1.5vw, 0.75rem);
            word-wrap: break-word;
            hyphens: auto;
        }

        > div {
            flex: 1;
            min-width: 0; // Flexbox overflow fix
        }

        @media (max-width: 1024px) {
            .form-drop-down-title {
                min-width: clamp(70px, 12vw, 100px);
                max-width: clamp(100px, 20vw, 140px);
            }
        }

        @media (max-width: 768px) {
            flex-direction: column;
            gap: 0;
            
            .form-drop-down-title {
                min-width: auto;
                max-width: none;
                padding-top: 0;
                margin-bottom: clamp(0.5rem, 1.2vw, 0.75rem);
                text-align: left;
            }

            > div {
                width: 100%;
            }
        }

        @media (max-width: 480px) {
            .form-drop-down-title {
                font-size: clamp(0.875rem, 2vw, 1rem);
            }
        }
    }

    .dropdown-align-right .form-drop-down-title {
        text-align: right;
    }

    .dropdown-align-left .form-drop-down-title {
        text-align: left;
    }

    .remove-options {
        margin-top: clamp(0.5rem, 1.2vw, 0.75rem);
    }

    .option-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: clamp(0.25rem, 0.8vw, 0.375rem);
        padding: clamp(0.375rem, 1vw, 0.5rem);
        background-color: rgba(248, 250, 252, 0.9);
        border: 1px solid rgba(226, 232, 240, 0.8);
        border-radius: 0.375rem;
        font-size: clamp(0.8rem, 1.6vw, 0.875rem);
        transition: all 0.2s ease;

        &:hover {
            background-color: rgba(241, 245, 249, 0.9);
            border-color: rgba(203, 213, 225, 0.8);
        }
    }

    .remove-button {
        background-color: #ef4444;
        color: white;
        border: none;
        padding: clamp(0.25rem, 0.6vw, 0.375rem) clamp(0.375rem, 0.8vw, 0.5rem);
        border-radius: 0.25rem;
        cursor: pointer;
        font-size: clamp(0.75rem, 1.4vw, 0.8rem);
        transition: all 0.2s ease;

        &:hover {
            background-color: #dc2626;
            transform: scale(1.05);
        }
    }
}
</style>

